import React from 'react';
import Spinner from './Spinner';

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  onClick,
  disabled = false,
  loading = false,
  leftIcon,
  rightIcon,
  type = 'button',
  className = '',
  fullWidth = false,
  ...props
}) => {
  const baseClasses =
    'inline-flex items-center justify-center gap-2 font-medium rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';

  const variants = {
    primary:
      'bg-gradient-to-r from-primary to-primary-dark text-white hover:from-primary-dark hover:to-primary focus:ring-primary shadow-md hover:shadow-lg transform hover:-translate-y-0.5',
    secondary:
      'bg-gradient-to-r from-secondary to-secondary-dark text-white hover:from-secondary-dark hover:to-secondary focus:ring-secondary shadow-md hover:shadow-lg transform hover:-translate-y-0.5',
    accent:
      'bg-gradient-to-r from-accent to-green-600 text-white hover:from-green-600 hover:to-green-700 focus:ring-accent shadow-md hover:shadow-lg transform hover:-translate-y-0.5',
    outline:
      'border-2 border-primary text-primary hover:bg-gradient-to-r hover:from-primary hover:to-primary-dark hover:text-white focus:ring-primary hover:shadow-md transform hover:-translate-y-0.5',
    ghost: 'text-primary hover:bg-primary/10 focus:ring-primary hover:shadow-sm',
    danger:
      'bg-gradient-to-r from-error to-red-700 text-white hover:from-red-700 hover:to-red-800 focus:ring-error shadow-md hover:shadow-lg transform hover:-translate-y-0.5',
    subtle:
      'bg-app-surface text-app-text hover:bg-app-surface-hover focus:ring-gray-300 border border-app-border',
  };

  const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-base',
    lg: 'px-6 py-3 text-lg',
    xl: 'px-8 py-4 text-xl',
  };

  const classes = `
    ${baseClasses}
    ${variants[variant] || variants.primary}
    ${sizes[size] || sizes.md}
    ${fullWidth ? 'w-full' : ''}
    ${className}
  `
    .trim()
    .replace(/\s+/g, ' ');

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={classes}
      aria-busy={loading || undefined}
      {...props}
    >
      {loading && <Spinner size="sm" />}
      {!loading && leftIcon}
      {children}
      {!loading && rightIcon}
    </button>
  );
};

export default Button;
